var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.69 13.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sunrise - ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-1",
    d: "M17.25,11.85A6,6,0,0,1,17,13.48c-1.65-.1-3.37-.15-5.15-.15s-3.51.05-5.16.15a5.33,5.33,0,0,1-.25-1.63,5.41,5.41,0,1,1,10.81,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-1",
    d: "M11.84,4.3a.5.5,0,0,1-.5-.5V.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V3.8A.5.5,0,0,1,11.84,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-1",
    d: "M17.53,6.66a.5.5,0,0,1-.5-.5.49.49,0,0,1,.15-.36l2.33-2.33a.5.5,0,0,1,.71,0,.52.52,0,0,1,0,.7L17.88,6.51A.51.51,0,0,1,17.53,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-1",
    d: "M23.19,12.34h-3.3a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h3.3a.51.51,0,0,1,.5.5A.5.5,0,0,1,23.19,12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-1",
    d: "M3.8,12.34H.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H3.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,3.8,12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-1",
    d: "M6.16,6.66a.53.53,0,0,1-.36-.15L3.47,4.18a.5.5,0,0,1,.71-.71L6.51,5.8a.51.51,0,0,1-.35.86Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.3dc8e1b0334e7dec9b6f2f65f538fcc7.svg";
export { ForwardRef as ReactComponent };